<template>
    <div>
        <Button v-show="isShowAllRead" type="text" style="box-shadow: none;" @click="setAllRead">全部标记为已读</Button>
        <Table :data="tableData1" :loading="loading" class="tableBorder" height="430" :columns="tableColumns1" size="small" :show-header="showheader"></Table>
        <br />
        <Row>
            <Col span="24">
            <Page :total="pageTotal" :page-size="pagesize" :current.sync="pageIndex" @on-change="changePage"></Page>
            </Col>
        </Row>
    </div>
</template>
<script>
export default {
    name: 'NoticeTable2',
    // props: { mydata: Object, },
    data() {
        return {
            tableData1: [], //this.mockTableData1(), //tabledata.tabrows,
            tableColumns1: [], //this.mockTableHeader(),
            showHeaders: [],
            pageTotal: 0,
            showheader: false,
            pageIndex: 1,
            isShowAllRead: false,
            unreadfile: [],
            pagesize: 10,
            src: '',//1=通用，2=专属，3=最新文件，4=效力变动,5=优惠项目，6=优惠税种
            loading: true,
        }
    },
    inject: ['CreatePage', 'getSliders', 'setOneLastFile', 'setAllLastFile', 'setOneTaxFile', 'setAllTaxFiles'],
    methods: {
        setAllRead() {
            // console.log(this.src)
            // console.log(this.tableData1)
            this.isShowAllRead = false
            if (this.src === 5) {
                this.setAllLastFile()
                this.tableData1.forEach(function(v) {
                    console.log(v)
                    v.isread = true
                })
            }else {
                //通知上层刷新UI
                this.setAllTaxFiles()
                this.$emit('setAllFilesIsRead')
            }
            //console.log(this.tableData1)
        },
        mockTableData2(tabrows) {
            //console.log(this.mydata)
            let da = [];
            let items = tabrows //this.mydata.tabrows
            if (items && items.length > 0) {
                for (var i = 0; i < items.length; i++) {
                    da.push({
                        fileid: items[i].strdocid,
                        filename: items[i].h1,
                        filenumber: items[i].h2,
                        desc: '',
                        isread: items[i].userread,
                        date: items[i].operatetime,
                        potence: items[i].potence,
                    })

                    if (!items[i].userread) {
                        this.unreadfile.push(items[i].userread)
                        //this.isShowAllRead = true
                    }
                    if (this.unreadfile.length > 0) {
                        this.isShowAllRead = true
                    } else {
                        this.isShowAllRead = false
                    }
                }
            }
            //console.log(da)
            return da;
        },

        mockTableHeader2(header, headerTitle) {
            var that = this
            let da = [];
            let items = header //this.mydata.header;
            let newHeaders = [];
            this.setHeader(headerTitle)
            for (var i = 0; i < items.length; i++) {
                if (this.showHeaders.indexOf(items[i].key) >= 0) {
                    newHeaders.push(items[i])
                }
            }
            //console.log(newHeaders)
            items = newHeaders;
            // da.push({
            //     type: 'index',
            //     width: 60,
            //     align: 'center'
            // })
            da.push({
                title: '序号',
                align: 'center',
                width: 60,
                sortable: true,
                render: (h, params) => {
                    return h('span', params.index + (this.pageIndex - 1) * this.pagesize + 1)
                }

            })
            for (var i = 0; i < items.length; i++) {
                if (items[i].key == "filename") {
                    da.push({
                        title: items[i].title,
                        key: items[i].key,
                        //align: items[i].align,
                        render: (createElement, params) => {
                            const row = params.row;
                            const text = row.filename;
                            const fileid = row.fileid;
                            const desc = row.desc;
                            const readstr = !row.isread ? '未读' : '';
                            const datestr = row.date
                            return createElement('div', {
                                style: {
                                    color: '#515a6e',
                                    marginTop: '5px',
                                    marginBottom: '5px',
                                }
                            }, [
                                createElement('a', {
                                    domProps: {
                                        innerHTML: `` + text + ``
                                    },
                                    on: {
                                        'click': () => {
                                            row.isread = true
                                            //设置文件已读
                                            if (that.src === 5) {
                                                that.setOneLastFile(fileid)
                                            } else {
                                                that.setOneTaxFile(fileid)
                                            }
                                            that.add(fileid, 1, text,row);
                                        }
                                    }
                                }, text + " "),
                                ' ',
                                desc,
                                createElement('Tag', {
                                    props: {
                                        color: 'warning',
                                    },
                                    style: {
                                        marginLeft: '20px',
                                        width: '60px',
                                        textAlign: 'center',
                                        display: !row.isread ? 'inline-block' : 'none'
                                    }
                                }, readstr),
                                createElement('p', {
                                    domProps: {
                                        innerHTML: `` + datestr + ``
                                    },
                                    style: {
                                        color: '515a6e'
                                    }
                                }),

                            ]);
                        }
                    })

                } else {
                    da.push({
                        title: items[i].title,
                        key: items[i].key,
                        // width: items[i].width,
                        //align: items[i].align,
                    })
                }

            }

            return da;
        },
        setOneFileIsRead() {

        },
        setHeader(arrayObj) {
            if (arrayObj == null || arrayObj == undefined || arrayObj.length == 0) {
                this.showHeaders = ['fileid', 'filename']

            } else {
                this.showHeaders = arrayObj
            }
        },
        changePage(index) {
            // The simulated data is changed directly here, and the actual usage scenario should fetch the data from the server
            //this.tableData1 = this.mockTableData1();
            // console.log('changepage===>')
            // console.log(index,this.src)
            this.loading = true
            this.$emit('changepage', index, this.src)
        },
        add(fid, orderid, filename,row) {
            this.setOneFileIsRead([fid])
            this.CreatePage(fid, orderid, filename,row);
        },
        reloadHeaderData(obj) {
            this.tableColumns1 = this.mockTableHeader2(obj);
        },
        show(data, type) {
            //console.log(data)
            this.src = type
            this.pageIndex = data.index
            this.tableName = data.tabname
            this.pageTotal = data.total
            this.tableData1 = this.mockTableData2(data.tabrows)
            this.tableColumns1 = this.mockTableHeader2(data.header, ['filename'])
            this.loading = false
            this.$nextTick(() => {
                this.loading = false
            })

        },

    },
    watch: {
        sliders: function() {
            // console.log(this.sliders)
            // this.reloadHeaderData(['filename']);
            // if (this.sliders.length == 0) {
            //     this.reloadHeaderData([]);
            // } else if (this.sliders.length > 0) {
            //     this.reloadHeaderData(['filename']);
            // }
        },
    },
}
</script>
<style scoped>
.tableBorder {
    /*border: 1px solid #dcdee2;*/
    border-bottom: none;
}

.tableBorder>.ivu-table>.ivu-table-overflowX {
    overflow-x: hidden;
}
</style>